import { render, staticRenderFns } from "./DialogBox.vue?vue&type=template&id=4a079acf&scoped=true"
import script from "./DialogBox.vue?vue&type=script&lang=js"
export * from "./DialogBox.vue?vue&type=script&lang=js"
import style0 from "./DialogBox.vue?vue&type=style&index=0&id=4a079acf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a079acf",
  null
  
)

export default component.exports